<template>
<div class="icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <g fill="none" fill-rule="evenodd" stroke="currentColor">
            <path stroke-linejoin="round" stroke-width="1.5" d="M12.045 20.571H7.5V32h25V20.571h-4.545"/>
            <path stroke-width="1.5" d="M12.795 8.75v15.643h14.41V8.75h-14.41z"/>
            <path stroke-linecap="round" stroke-width="1.5" d="M10.91 24.571h18.192"/>
            <path stroke-linecap="round" d="M16.3 12.571h7.423M16.3 16h3.711"/>
        </g>
    </svg>
</div>
</template>

<script setup>
</script>